import { render, staticRenderFns } from "./purchaseQuality.vue?vue&type=template&id=2ed93f9b&scoped=true"
import script from "./purchaseQuality.vue?vue&type=script&lang=js"
export * from "./purchaseQuality.vue?vue&type=script&lang=js"
import style0 from "./purchaseQuality.vue?vue&type=style&index=0&id=2ed93f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed93f9b",
  null
  
)

export default component.exports